import { getSafeSsoContinuation } from './getSafeSsoContinuation';

const createOauthState = () => {
  const randomBytes = new Uint8Array(32);
  window.crypto.getRandomValues(randomBytes);
  return Array.from(randomBytes, (value) => value.toString(16).padStart(2, '0')).join('');
};

export const createSsoLoginRedirectUrl = (redirectUrl: string, goto: string | null, logoutUrl?: string | null) => {
  const url = new URL(redirectUrl, window.location.origin);

  if (url.protocol !== 'https:' && url.protocol !== 'http:') {
    throw new Error('The SSO provider returned an invalid login URL.');
  }

  const state = url.searchParams.get('state') || createOauthState();
  url.searchParams.set('state', state);
  window.sessionStorage.setItem('sso.oauthState', state);
  window.sessionStorage.setItem('sso.continuation', getSafeSsoContinuation(goto));

  if (logoutUrl) {
    const parsedLogoutUrl = new URL(logoutUrl, window.location.origin);

    if (parsedLogoutUrl.protocol !== 'https:' && parsedLogoutUrl.protocol !== 'http:') {
      throw new Error('The SSO provider returned an invalid logout URL.');
    }

    window.sessionStorage.setItem('sso.logoutUrl', parsedLogoutUrl.toString());
  } else {
    window.sessionStorage.removeItem('sso.logoutUrl');
  }

  return url.toString();
};
